/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EmployeePositionDTO = {
    SPA_BEAUTICIAN: 'SPA_BEAUTICIAN',
    SPA_HAIRDRESSER: 'SPA_HAIRDRESSER',
    SPA_HEAD_TRAINER: 'SPA_HEAD_TRAINER',
    SPA_MANAGER: 'SPA_MANAGER',
    SPA_RECEPTIONIST: 'SPA_RECEPTIONIST',
    SPA_SUPERVISOR: 'SPA_SUPERVISOR',
    SPA_THERAPIST: 'SPA_THERAPIST',
    SPA_TRAINER: 'SPA_TRAINER'
} as const;
export type EmployeePositionDTO = typeof EmployeePositionDTO[keyof typeof EmployeePositionDTO];

